import { render, staticRenderFns } from "./tvs_structure.vue?vue&type=template&id=955dfefa&scoped=true"
import script from "./tvs_structure.vue?vue&type=script&lang=js"
export * from "./tvs_structure.vue?vue&type=script&lang=js"
import style0 from "./tvs_structure.vue?vue&type=style&index=0&id=955dfefa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "955dfefa",
  null
  
)

export default component.exports